import { FormSection, Radio } from '@ksyos/design-system';
import type {
    BariPostDietitianReportData,
    BariPostDietitianReportVervolgstap,
} from '@common/validation/customControls/bariPost/bariPostDietitianReport/v1/bariPostDietitianReportSchemaV1';
import { orderedPractitionerTypes, TypeBehandelaar, Vervolgstap } from '@common/customControls/bariatrics';
import { bariPostDietitianReportVervolgstappen } from '@common/validation/customControls/bariPost/bariPostDietitianReport/v1/bariPostDietitianReportSchemaV1';
import { ProcessActivityAssetsDropzone } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import {
    RadioGroupFormGroup,
    SelectFormGroup,
    TextAreaFormGroup,
    TextInputFormGroup,
} from '../../processActivityFormGroupFields';

export function BariPostDietitianReportEdit(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPostDietitianReportData>();

    return (
        <>
            <FormSection title="Verslag">
                <TextAreaFormGroup
                    fieldKey="verslag"
                    isRequired={true}
                    label="Verslag"
                    placeholder="Typ je verslag..."
                />
                <TextAreaFormGroup
                    fieldKey="hulpvraag"
                    label="Hulpvraag"
                    placeholder="Typ je hulpvraag..."
                />
                <TextAreaFormGroup
                    fieldKey="interventie"
                    label="Interventie"
                    placeholder="Typ je interventie..."
                />
                <ProcessActivityAssetsDropzone label="Bestand(en)" />
            </FormSection>

            <FormSection title="Vervolgstap">
                <RadioGroupFormGroup
                    fieldKey="vervolgstap"
                    isRequired={true}
                    label="Vervolgstap"
                    onChange={async (value) => {
                        onChange({
                            reden_doorverwijzing: null,
                            type_behandelaar: null,
                            type_behandelaar_overig: null,
                            vermoedelijke_diagnose: null,
                            vervolgstap: value as BariPostDietitianReportVervolgstap,
                        });
                    }}
                >
                    {bariPostDietitianReportVervolgstappen.map((value) => (
                        <Radio
                            key={value}
                            label={value}
                            value={value}
                        />
                    ))}
                </RadioGroupFormGroup>

                {data.vervolgstap === Vervolgstap.doorverwijzen_extern_buiten_zorgpad && (
                    <>
                        <TextAreaFormGroup
                            fieldKey="vermoedelijke_diagnose"
                            isRequired={true}
                            label="Vermoedelijke diagnose"
                            placeholder="Typ je diagnose..."
                            tooltipText="Deze informatie ontvangt de huisarts en/of doorverwijzer."
                        />
                        <SelectFormGroup
                            fieldKey="type_behandelaar"
                            isRequired={true}
                            label="Type behandelaar"
                            onChange={(value) =>
                                onChange(
                                    {
                                        type_behandelaar: value as TypeBehandelaar | null,
                                        type_behandelaar_overig: null,
                                    },
                                    'type_behandelaar'
                                )
                            }
                            options={orderedPractitionerTypes.map((practitionerType) => ({
                                label: practitionerType,
                                value: practitionerType,
                            }))}
                            placeholder="Selecteer type behandelaar"
                            tooltipText="Geef aan naar welke soort behandelaar je wil doorsturen: een psychiater bijvoorbeeld."
                        />
                        {data.type_behandelaar === TypeBehandelaar.overig && (
                            <TextInputFormGroup
                                fieldKey="type_behandelaar_overig"
                                isRequired={true}
                                label="Type behandelaar overig"
                            />
                        )}
                        <TextAreaFormGroup
                            fieldKey="reden_doorverwijzing"
                            isRequired={true}
                            label="Reden doorverwijzing"
                            placeholder="Typ je reden..."
                        />
                    </>
                )}
            </FormSection>
        </>
    );
}
